<template>
  <v-dialog v-model="opened" max-width="1000" persistent>
    <v-form
      ref="form"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? "Tambah" : "Ubah" }} Paket
          <v-btn icon @click="close" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-text-field
                  label="Slug"
                  required
                  dense
                  outlined
                  :disabled="true"
                  v-model="data.slug"
                  :rules="rules.slug"
                />
              </v-col>
            </v-row>

            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-text-field
                  label="Nama Paket"
                  required
                  dense
                  outlined
                  v-model="data.name"
                  :rules="rules.name"
                  :readonly="!!id" 
                />

                <CurrencyInput
                  v-model="data.price_bottom"
                  label="Harga Bottom"
                  :rules="rules.price_bottom"
                  placeholder="Masukkan harga bottom"
                />

                <CurrencyInput
                  v-model="data.price_sales"
                  label="Harga Sales"
                  :rules="rules.price_sales"
                  placeholder="Masukkan harga sales"
                />

                <v-radio-group
                  v-model="data.package_type"
                  row
                  label="Tipe Paket"
                  :rules="[(v) => !!v || 'Tipe paket wajib dipilih']"
                  @change="handlePackageTypeChange"
                  :disabled="!!id" 
                >
                  <v-radio label="Paket Bulanan" value="monthly" />
                  <v-radio label="Paket Sesi" value="session" />
                  <v-radio label="Paket Kelas" value="class" />
                </v-radio-group>

                <v-text-field
                  v-if="data.is_monthly || data.is_class"
                  label="Durasi (Bulan)"
                  dense
                  outlined
                  v-model="data.duration_month"
                  :rules="rules.duration_month"
                  @keypress="isNumber($event)"
                  :readonly="!!id"
                />

                <v-text-field
                  v-if="data.is_session"
                  label="Jumlah Sesi"
                  dense
                  outlined
                  v-model="data.session_count"
                  :rules="rules.session_count"
                  @keypress="isNumber($event)"
                  :readonly="!!id"
                />

                <v-autocomplete
                  v-if="data.is_class"
                  label="Kelas"
                  dense
                  outlined
                  v-model="data.class_type_id"
                  :items="listClassType"
                  item-text="name"
                  item-value="id"
                  :rules="rules.class_type_id"
                  @keypress="isNumber($event)"
                  :disabled="!!id"
                />

                <v-textarea
                  label="Deskripsi"
                  dense
                  outlined
                  v-model="data.description"
                  :readonly="!!id"
                />
                <v-radio-group
                  v-model="data.category"
                  row
                  label="Kategori"
                  :rules="[(v) => !!v || 'Kategori wajib dipilih']"
                  :disabled="!!id"
                >
                  <v-radio label="Personal" value="personal"></v-radio>
                  <v-radio label="Corporate" value="corporate"></v-radio>
                </v-radio-group>

                <v-radio-group
                  v-model="data.is_active"
                  row
                  label="Status"
                >
                  <v-radio label="Aktif" :value="true"></v-radio>
                  <v-radio label="Tidak Aktif" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" align="end">
              <v-btn depressed class="ma-1" :disabled="loading" @click="close">
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                v-if="canEdit"
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { slugify } from "@/core/utils";
import { isNumber } from "@/core/utils";

export default {
  async mounted() {
    const classType = await ApiService.get("class-type/list");
    this.listClassType = classType.data.filter((item) => !item.is_free);
    // this.listClassType = classType.data;
  },
  data() {
    return {
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      listClassType: [],
      data: {
        slug: null,
        name: null,
        price_bottom: 0,
        price_sales: 0,
        is_monthly: false,
        is_session: false,
        is_class: false,
        duration_month: null,
        session_count: null,
        class_type_id: null,
        description: null,
        package_type: null,
        category: "personal",
        is_active: true,
      },
      rules: {
        slug: [(v) => !!v || "Slug is required"],
        name: [(v) => !!v || "Name is required"],
        duration_month: [
          (v) => {
            if (this.data.is_monthly || this.data.is_class) {
              return !!v || "Durasi wajib diisi";
            }
            return true;
          },
        ],
        session_count: [
          (v) => {
            if (this.data.is_session) {
              return !!v || "Jumlah sesi wajib diisi";
            }
            return true;
          },
        ],
        class_type_id: [
          (v) => {
            if (this.data.is_class) {
              return !!v || "Kelas wajib dipilih";
            }
            return true;
          },
        ],
        price_bottom: [
          (v) => !!v || "Harga Sales wajib diisi",
        ],
        price_sales: [
          (v) => !!v || "Harga Sales wajib diisi",
        ],
      },
    };
  },
  props: {
    module: String,
    success: Function,
  },
  methods: {
    isNumber,
    open(id) {
      this.opened = true;
      setTimeout(() => {
        this.$refs.form.reset();
        if (id) this.getData(id);
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      ApiService.get(`package?id=${id}`)
        .then(({ data }) => {
          this.data = { ...data };
          // Pastikan hanya satu tipe yang aktif
    this.data.package_type = 
      data.is_monthly ? 'monthly' :
      data.is_session ? 'session' :
      data.is_class ? 'class' : null;
    
          this.loadingData = false;
        })
        .catch(({ response }) => {
          this.handleError(response.data);
          this.loadingData = false;
        });
    },
    async save() {
      this.valid = await this.$refs.form.validate();
      if (
        [this.data.is_monthly, this.data.is_session, this.data.is_class].filter(
          Boolean
        ).length > 1
      ) {
        this.$swal.fire({
          icon: "warning",
          title: "Validasi Gagal",
          text: "Hanya boleh memilih satu jenis paket.",
        });
        return;
      }

      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "package";
        if (this.id) url += `?id=${this.id}`;
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                timer: 3000,
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            this.handleError(response.data);
            this.loading = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data?.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.$refs.form.reset();
    },
    handlePackageTypeChange(val) {
    
    // Reset semua tipe paket
    this.data.is_monthly = false;
    this.data.is_session = false;
    this.data.is_class = false;
    
    // Set yang dipilih
    if (val === 'monthly') this.data.is_monthly = true;
    if (val === 'session') this.data.is_session = true;
    if (val === 'class') this.data.is_class = true;
    
    // Reset nilai yang tidak relevan
    if (val !== 'monthly' && val !== 'class') this.data.duration_month = null;
    if (val !== 'session') this.data.session_count = null;
    if (val !== 'class') this.data.class_type_id = null;
    
    // Force update
    this.$forceUpdate();
  }
  },
  watch: {
    "data.name"(val) {
      this.data.slug = val ? slugify(val) : null;
    },
    "data.package_type"(val) {
      this.data.is_monthly = val === "monthly";
      this.data.is_session = val === "session";
      this.data.is_class = val === "class";
    },
  },
  computed: {
    canEdit() {
      return (
        !this.id || this.$store.getters.hasPermission(this.module, "update")
      );
    },
  },
};
</script>
